// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'


const firebaseConfig = {
  apiKey: "AIzaSyCFT-RqOxsrXrUgtOv80IDk8VPnV9LRgvM",
  authDomain: "populibot-43185.firebaseapp.com",
  projectId: "populibot-43185",
  storageBucket: "populibot-43185.firebasestorage.app",
  messagingSenderId: "314081667795",
  appId: "1:314081667795:web:56753365a557a8a9c2c226",
  measurementId: "G-SSKJE7HVQ6"
};
  


const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app) // <-- Storage referansı
